import React, { Component } from 'react';

import ContentOuterBound from './common/atoms/ContentOuterBound';
import ContentSpacer from './common/atoms/ContentSpacer';
import NavigableListMolecule from './common/molecules/NavigableList';

import * as Breakpoints from '../constants/breakpoints';
import * as InternalPropTypes from '../constants/internal-types';
import {
  TypeBackgroundColorTypes,
  TypeSEOWeightTypes,
} from '../constants/cms-constants';
import SEOWeights from '../constants/cms/control-options/seo-weights';

const styles = {
  [Breakpoints.Mobile.mq]: {
    paddingTop: '24px',
    paddingBottom: '24px',
  },
  [Breakpoints.Tablet.mq]: {
    paddingTop: '64px',
    marginBottom: '100px',
  },
  [Breakpoints.DesktopUp.mq]: {
    paddingTop: '64px',
  },
};

type NavigableListProps = {
  content?: InternalPropTypes.MediaItem[];
  backgroundColor?: TypeBackgroundColorTypes;
  seoWeight?: TypeSEOWeightTypes;
};

class NavigableList extends Component<NavigableListProps> {
  static defaultProps = {
    content: [],
    backgroundColor: null,
    seoWeight: SEOWeights.H2,
  };

  render() {
    const { content, backgroundColor, seoWeight } = this.props;

    const addStyle = backgroundColor ? { background: backgroundColor } : {};
    return (
      <div className="nav-list-component" css={[styles, addStyle]}>
        <ContentOuterBound>
          <ContentSpacer>
            <NavigableListMolecule content={content} seoWeight={seoWeight} />
          </ContentSpacer>
        </ContentOuterBound>
      </div>
    );
  }
}

export default NavigableList;
